import { Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'sbnb-connect-agoda-requirements-fail',
  templateUrl: './connect-agoda-requirements-fail.component.html',
  styleUrls: ['./connect-agoda-requirements-fail.component.scss'],
})
export class ConnectAgodaRequirementsFailComponent implements OnInit {
  failed: string;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((res) => {
      this.failed = res.failed;
    });
  }

  finish() {
    this.router.navigate(['/properties']);
  }

  connectAnother() {
    this.router.navigate(['/accounts/new/agoda']);
  }
}
